export default __webpack_public_path__ + "static/media/img13.03df4e18.png";